import { Component } from '@angular/core';
import { JeevesOrderDetailsComponent } from 'gung-standard-jeeves';

@Component({
  selector: 'colmec-order-details',
  templateUrl: './colmec-order-details.component.html',
  styleUrls: ['./colmec-order-details.component.scss'],
  standalone: false
})
export class ColmecOrderDetailsComponent extends JeevesOrderDetailsComponent {
  hidePrice: boolean;

  constructor() {
    super();
    this.priceConfigService.hidePrice.subscribe(hidePrice => (this.hidePrice = hidePrice));
  }
}
